// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__20OnJ","bigColWidth":"Table_bigColWidth__339ne","biggerColWidth":"Table_biggerColWidth__2n267","row":"Table_row__1W_HU","col":"Table_col__1phII"};